import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { DesignContent } from './components/DesignContent';
import { CaseStudyContent } from './components/CaseStudyContent';
import { Logo } from './components/Logo';
import { MobileMenu } from './components/MobileMenu';
import { HomePage } from './components/HomePage';
export function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // Derive active page from URL path
  const path = location.pathname.substring(1);
  const activePage = path || 'home';
  const isHome = activePage === 'home';
  const isCaseStudy = activePage.startsWith('work/');
  // Set document language to Australian English
  useEffect(() => {
    document.documentElement.lang = 'en-AU';
  }, []);
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  const handleNavigate = (page: string) => {
    navigate(page === 'home' ? '/' : `/${page}`);
    setIsMobileMenuOpen(false);
  };
  return <div className={`w-full min-h-screen ${isHome ? 'bg-[#111111] text-white overflow-hidden' : 'bg-white text-black'} transition-colors duration-500`} data-id="element-0">
      {/* Persistent Logo */}
      <div className={`fixed top-0 left-0 h-[80px] px-8 flex items-center z-50`} data-id="element-1">
        <Logo onClick={() => handleNavigate('home')} currentPage={activePage} data-id="element-2" />
      </div>

      {/* Persistent Copyright & LinkedIn */}
      <div className={`fixed bottom-0 left-0 right-0 px-8 py-6 z-50 flex justify-between items-center ${activePage !== 'home' ? 'hidden md:flex' : 'flex'}`} data-id="element-3">
        <p className="text-fluid-sm text-[#7A8290]" data-id="element-4">© All rights reserved</p>
        <a href="https://www.linkedin.com/in/mintextract/" target="_blank" rel="noopener noreferrer" className={`text-fluid-sm text-[#7A8290] transition-colors duration-300 ${isHome ? 'hover:text-white' : 'hover:text-[#111111]'}`} data-id="element-5">
          LinkedIn
        </a>
      </div>

      {/* Mobile Menu */}
      <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} activePage={activePage} onNavigate={handleNavigate} data-id="element-6" />

      {/* Page Content — only the active page is in the DOM */}
      {isHome && <HomePage onNavigate={handleNavigate} data-id="element-7" />}

      {!isHome && <div className="flex min-h-screen" data-id="element-8">
          <div className="hidden md:block" data-id="element-9">
            <Sidebar activePage={activePage} onNavigate={handleNavigate} data-id="element-10" />
          </div>
          {isCaseStudy ? <CaseStudyContent activePage={activePage} onNavigate={handleNavigate} onOpenMobileMenu={() => setIsMobileMenuOpen(true)} data-id="element-11" /> : <DesignContent activePage={activePage} onNavigate={handleNavigate} onOpenMobileMenu={() => setIsMobileMenuOpen(true)} data-id="element-12" />}
        </div>}
    </div>;
}